/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const interviewAdhocAttendeeDtoSchema = z.object({ "email": z.string().nullish(), "firstName": z.string().nullish(), "lastName": z.string().nullish() });
export type InterviewAdhocAttendeeDto = z.infer<typeof interviewAdhocAttendeeDtoSchema>;
